/* FR Fencing - Purchase button: unit price x quantity (live) + pre-order awareness.
   When the selected variant is a pre-order (out of stock but continue-selling), the label
   becomes "Precommander", a delay note is shown, and a line-item property is enabled.
   Written without regex or non-ASCII so the theme upload stays byte-safe. */
(function () {
  function money(cents, fmt) {
    cents = Math.round(cents);
    var open = fmt.indexOf('{' + '{');
    var close = fmt.indexOf('}' + '}');
    var name = (open === -1 || close === -1) ? 'amount_with_comma_separator' : fmt.slice(open + 2, close).trim();

    var decimals = 2, thousands = '.', decimal = ',';
    if (name === 'amount') { decimals = 2; thousands = ','; decimal = '.'; }
    else if (name === 'amount_no_decimals') { decimals = 0; thousands = ','; decimal = '.'; }
    else if (name === 'amount_with_comma_separator') { decimals = 2; thousands = '.'; decimal = ','; }
    else if (name === 'amount_no_decimals_with_comma_separator') { decimals = 0; thousands = '.'; decimal = ','; }
    else if (name === 'amount_with_apostrophe_separator') { decimals = 2; thousands = "'"; decimal = '.'; }
    else if (name === 'amount_with_space_separator') { decimals = 2; thousands = ' '; decimal = ','; }
    else if (name === 'amount_no_decimals_with_space_separator') { decimals = 0; thousands = ' '; decimal = ','; }

    var fixed = (cents / 100).toFixed(decimals);
    var dot = fixed.indexOf('.');
    var intPart = dot === -1 ? fixed : fixed.slice(0, dot);
    var fracPart = dot === -1 ? '' : fixed.slice(dot + 1);

    var grouped = '', cnt = 0;
    for (var i = intPart.length - 1; i >= 0; i--) {
      grouped = intPart.charAt(i) + grouped;
      cnt++;
      if (cnt % 3 === 0 && i > 0) grouped = thousands + grouped;
    }
    var num = grouped + (decimals > 0 && fracPart ? decimal + fracPart : '');
    if (open === -1 || close === -1) return num;
    return fmt.slice(0, open) + num + fmt.slice(close + 2);
  }

  function parseIds(root) {
    var el = root.querySelector('[data-fr-preorder-ids]');
    if (!el) return [];
    try { var a = JSON.parse(el.textContent); return (a && a.length) ? a : []; } catch (e) { return []; }
  }

  function init(root) {
    if (!root || root.dataset.frAtcPriceBound === '1') return;
    var btn = root.querySelector('.product-form__submit');
    if (!btn) return;
    root.dataset.frAtcPriceBound = '1';

    var fmtEl = root.querySelector('[data-fr-money-format]');
    var fmt = '{' + '{amount_with_comma_separator}}' + String.fromCharCode(0x20AC);
    if (fmtEl) { try { var parsed = JSON.parse(fmtEl.textContent); if (parsed) fmt = parsed; } catch (e) {} }

    var unitPrice = parseInt(btn.getAttribute('data-fr-unit-price'), 10);
    var addLabel = btn.getAttribute('data-fr-add-label') || '';
    var preLabel = btn.getAttribute('data-fr-preorder-label') || addLabel;
    var preIds = parseIds(root);
    var noteEl = root.querySelector('[data-fr-preorder-note]');
    var propEl = root.querySelector('[data-fr-preorder-prop]');

    function isPre(id) {
      if (id === null || id === undefined || id === '') return false;
      id = Number(id);
      for (var i = 0; i < preIds.length; i++) { if (Number(preIds[i]) === id) return true; }
      return false;
    }
    function currentVariantId() {
      var idInput = root.querySelector('.product-variant-id') || root.querySelector('input[name="id"]');
      return idInput ? idInput.value : null;
    }
    function applyPreorder(pre) {
      if (noteEl) { noteEl.hidden = !pre; }
      if (propEl) { propEl.disabled = !pre; }
    }

    function qty() {
      var qi = root.querySelector('.quantity__input') || root.querySelector('[name="quantity"]');
      var q = qi ? parseInt(qi.value, 10) : 1;
      return (isNaN(q) || q < 1) ? 1 : q;
    }
    function render() {
      if (isNaN(unitPrice)) return;
      var el = btn.querySelector('[data-fr-atc-total]');
      if (!el) return;
      el.innerHTML = money(unitPrice * qty(), fmt);
    }
    function setLabel(pre) {
      var span = btn.querySelector('span');
      if (!span) return;
      var base = pre ? preLabel : ((window.variantStrings && window.variantStrings.addToCart) || addLabel);
      span.innerHTML = base + ' &middot; <span data-fr-atc-total></span>';
    }
    // After a variant change, Dawn (product-form.js) rewrites the button label to plain
    // add-to-cart text, so we re-append the right label + total price and sync pre-order UI.
    function rebuildAfterVariant(variant) {
      var pre = !!(variant && variant.available !== false && isPre(variant.id));
      applyPreorder(pre);
      if (!variant || variant.available === false) return; // sold out / unavailable: keep Dawn's text
      if (typeof variant.price === 'number') unitPrice = variant.price;
      setLabel(pre);
      render();
    }

    root.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.classList && t.classList.contains('quantity__input')) render();
    });
    root.addEventListener('input', function (e) {
      var t = e.target;
      if (t && t.classList && t.classList.contains('quantity__input')) render();
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      if (PUB_SUB_EVENTS.variantChange) {
        subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
          if (event && event.data) rebuildAfterVariant(event.data.variant);
        });
      }
      if (PUB_SUB_EVENTS.quantityUpdate) {
        subscribe(PUB_SUB_EVENTS.quantityUpdate, render);
      }
    }
    // Initial sync: the server already rendered the correct label; just align note/prop + price.
    applyPreorder(isPre(currentVariantId()));
    render();
  }

  function boot() {
    var roots = document.querySelectorAll('product-info');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
